// Historical orders are not assigned a daily number retrospectively.
export const orderIdentifier = (order) => {
  const dailyNumber = order?.dailyNumber;
  if (dailyNumber == null || dailyNumber === "") return "Sin número diario";
  const prefix = order?.SalesChannel?.identifier;
  return prefix ? `${prefix}-${dailyNumber}` : String(dailyNumber);
};
